import { useSuspenseQuery } from '@apollo/client';

import { IndustryByIdDocument } from '../../graphql/queries/industry-by-id.gql-types';
import { useAllIndustries } from '../use-companies-industries/use-companies-industries';

interface UseIndustryIdProps {
  industrySEOName: string;
  segmentSEOName?: string;
}

const extractIdFromScrambledId = (scrambledId?: string): string | undefined => {
  return scrambledId?.split('.')[0];
};

const NOT_FOUND_ID = '-1';

export const useIndustryId = ({
  industrySEOName,
  segmentSEOName,
}: UseIndustryIdProps) => {
  const { orderedIndustries } = useAllIndustries();

  // Find the industry by SEO name
  const industryResult = orderedIndustries.find(
    (el) => el?.industry?.seoName === industrySEOName
  );
  const scrambledIndustryId = industryResult?.industry?.id ?? NOT_FOUND_ID;
  const industryId =
    extractIdFromScrambledId(scrambledIndustryId) ?? NOT_FOUND_ID;

  // Query industry details using suspense
  const { data: responseData } = useSuspenseQuery(IndustryByIdDocument, {
    variables: { id: scrambledIndustryId },
    skip: scrambledIndustryId === NOT_FOUND_ID,
  });

  // Find the segment by SEO name
  const segments = responseData?.industryById?.segments;
  const segmentResult = segments?.find(
    (segment) => segment.seoName === segmentSEOName
  );
  const scrambleSegmentId = segmentResult?.id ?? NOT_FOUND_ID;
  const segmentId = extractIdFromScrambledId(scrambleSegmentId) ?? NOT_FOUND_ID;

  return {
    scrambledIndustryId,
    industryId,
    scrambleSegmentId,
    segmentId,
  };
};
